import {RailsApi} from '@/api/rails.api.js'

/**
 * Timezones API service
 */
export class TimezonesApi extends RailsApi {

  //Props
  basePath = '/timezones'
  itemsKey = 'timezones'
}

//Export singleton instance
export const timezonesApi = new TimezonesApi()
